import type { UserProfile as BaseUserProfile } from '@nvision/identity-core';

import { generateUUIDv4 } from '@/utils/number';

interface UserProfile extends Omit<BaseUserProfile, 'userType'> {
  id: number;
  applicationID: number;
  userGuid: string;
  userType: 'CARR' | 'VEND' | 'CUST';
}

export const normalizeUserData = (profileData?: BaseUserProfile): UserProfile | undefined => {
  // NOTE: This function is a temporary bridge for legacy authentication.
  // Once the old authentication system is fully deprecated, remove normalizeUserData.
  // and update logic based on userType applicationID  and userGuid
  if (!profileData) {
    return undefined;
  }

  const userTypes = {
    carrier: 'CARR',
    customer: 'CUST',
    vendor: 'VEND',
  } as const;

  return {
    ...profileData,
    applicationID: Number(profileData.ApplicationID),
    id: Number(profileData.sub),
    userGuid: generateUUIDv4(),
    userType: userTypes[profileData.userType],
  };
};
